module.exports = __webpack_public_path__ + "static/media/picture-(56).7c01753a.JPG";